
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#000","d":"M.454 2.368L2.575.247l17.678 17.677-2.122 2.122z"}}),_c('path',{attrs:{"fill":"#000","d":"M18.132.247l2.121 2.122L2.576 20.046.454 17.925z"}})])
          )
        }
      }
    